const PreserviceProgramTypeEnum = Object.freeze([
    {
        name: "Specialty",
        code: "SPECIALTY",
    },
    {
        name: "Sub-specialty",
        code: "SUBSPECIALTY",
    },
    {
        name: "Super-specialty",
        code: "SUPERSPECIALTY",
    },
    {
        name: "Ultra-specialty",
        code: "ULTRASPECIALTY",
    },
]);

export default PreserviceProgramTypeEnum;
